import { FC } from 'react';

import { downloadFile } from '../../pages/documents/templates/utils/download-file.util';
import { selectedCompanyStorage } from '../../storage/company/selected-company.util';
import { openCompanyStorageUrlInNewTab } from '../../utils/company-storage-url.util';
import Button from '../button/index';

export type StorageDocumentLinkProps = {
  className?: string;
  label: string;
  link: string;
  localFile?: File;
  onDocumentClick?: (fileLink: string) => void;
};

export const StorageDocumentLink: FC<StorageDocumentLinkProps> = ({
  className = 'h-auto w-full min-w-0 cursor-pointer justify-start overflow-hidden p-0 text-left text-xs font-[450] text-brand-700 underline',
  label,
  link,
  localFile,
  onDocumentClick,
}) => {
  const companyId = selectedCompanyStorage(({ companyId }) => companyId);
  const canOpen = Boolean(localFile || onDocumentClick || companyId);

  if (!canOpen) {
    return (
      <span className="block min-w-0 truncate text-xs font-[450] text-gray-700" title={label}>
        {label}
      </span>
    );
  }

  const handleClick = () => {
    if (localFile) {
      downloadFile(localFile);
      return;
    }
    if (onDocumentClick) {
      onDocumentClick(link);
      return;
    }
    if (companyId) {
      void openCompanyStorageUrlInNewTab(companyId, link);
    }
  };

  return (
    <Button
      className={className}
      onClick={handleClick}
      styleType="NONE"
      title={label}
      type="button"
    >
      <span className="block w-full min-w-0 truncate">{label}</span>
    </Button>
  );
};
